import {app} from "@/app";
import {get, waitFor} from "@/helpers";
import {AbstractShopifyPageObserver} from "@/services/observer/shopify/pages/AbstractShopifyPageObserver";

export class CheckoutPayment extends AbstractShopifyPageObserver {
  isApplicable(): boolean {
    return app.storage.shopify.page.type === app.storage.shopify.page.types.checkoutPayment;
  }

  async resolve() {
    app.debug('Shopify Event PageLoad CheckoutPayment: started');

    // wait for shopify payment form to load
    await waitFor(() => window.document.querySelector("form[data-payment-form]") != null, 500)
      .then(delay => {
        if(delay != 0) {
          app.debug('Shopify Event: Page: CheckoutPayment: waited for payment form successfully', delay);
        }

        app.debug('Shopify Event: Page: CheckoutPayment: attaching event to submit button');

        const submitButton = window.document.querySelector("form[data-payment-form] button[type=submit]");
        if(!submitButton) return;
        submitButton.addEventListener("click", function(e) {
          app.debug('Shopify Event: Page: CheckoutPayment: payment provided, loading cart');

          app.storage.shopify.cart.fetchCart().then(() => {
              app.pixel.events.shopify.addPaymentInfo.handle();
          })

        }, false);
      })
      .catch((delay) => {
        app.debug('Shopify Event: Page: CheckoutPayment: waited for payment form unsuccessfully', delay, 'warn');
      });
  }

}
